// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selection-group[data-v-c7e987c2] {\n  height: 90px;\n}\n.autoscale-label[data-v-c7e987c2] label {\n  font-size: 0.75em;\n}", ""]);
// Exports
module.exports = exports;
